jQuery(document).ready(function() {



    const callback = window.localStorage.getItem('afterLoad');

    if (callback) {

        const data = JSON.parse(window.localStorage.getItem('afterLoadData'));
        window.localStorage.removeItem('afterLoad');
        window.localStorage.removeItem('afterLoadData');

        const cb = eval('(' + callback + ')');

        cb(data);
    }
});